import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import Menu from './Menu'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'

const mapStateToProps = state => ({
  isMobile: getUIWindowSizesWidth(state) < 769,
})

export default withRouter(connect(mapStateToProps)(withTranslation('user')(Menu)))
